var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.close,
          expression: "close",
        },
      ],
      staticClass: "c-autocomplete c-autocomplete--alt",
    },
    [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.keywords,
            expression: "keywords",
          },
        ],
        staticClass: "c-autocomplete__input",
        attrs: {
          type: "text",
          placeholder: _vm.placeholder,
          autocomplete: "off",
        },
        domProps: { value: _vm.keywords },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) return
              _vm.keywords = $event.target.value
            },
            _vm.search,
          ],
          change: function ($event) {
            return _vm.select(_vm.keywords)
          },
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "c-autocomplete__results",
          class: { "c-autocomplete__results--open": _vm.visible },
        },
        [
          _c(
            "ul",
            { staticClass: "c-autocomplete__results-list" },
            _vm._l(_vm.results, function (result, index) {
              return _c(
                "li",
                {
                  key: index,
                  staticClass: "autocomplete-result",
                  attrs: { value: result.name },
                  on: {
                    click: function ($event) {
                      return _vm.select(result)
                    },
                  },
                },
                [
                  _c("span", [_vm._v(_vm._s(result.name))]),
                  _vm._v(" "),
                  _c("span", [_vm._v("(" + _vm._s(result.count) + ")")]),
                ]
              )
            }),
            0
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }